import React from 'react';

import { prefetchGetAboutContent } from '@lumirental/lumi-web-shared/lib/tanStackQuery/about.queries';
import { prefetchQueries } from '@lumirental/lumi-web-shared/lib/tanStackQuery/prefetchQueries';

import SEOTitle from '@/components/SeoTitle';
import TermsContainer from '@/containers/TermsContainer';

export async function getServerSideProps() {
  const { dehydratedState } = await prefetchQueries([
    prefetchGetAboutContent(),
  ]);

  return {
    props: {
      dehydratedState,
    },
  };
}

export default function TermsPage({ store }) {
  const pageSEOMetaData = store.appStore.config.getPageSEOMetaData('terms');

  return (
    <>
      <SEOTitle pageSEOMetaData={pageSEOMetaData} />
      <TermsContainer />
    </>
  );
}
